<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Nombre">
            <b-form-input
              class="form-control"
              type="text"
              v-model="usuario.nombre"
              placeholder="Samuel"
              data-vv-validate-on="blur|input"
              data-vv-name="nombre"
              v-validate.initial="'required'"
              :state="!errors.has('nombre')"
            />
            <span class="text-danger fs-6" v-show="errors.has('nombre')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Apellido">
            <b-form-input
              class="form-control"
              type="text"
              v-model="usuario.apellido"
              placeholder="Matos Castillo"
              data-vv-validate-on="blur|input"
              data-vv-name="apellido"
              v-validate.initial="'required'"
              :state="!errors.has('apellido')"
            />
            <span class="text-danger fs-6" v-show="errors.has('apellido')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Usuario">
            <b-form-input
              class="form-control"
              type="text"
              v-model="usuario.codigo"
              placeholder="RC1121"
              data-vv-validate-on="blur|input"
              data-vv-name="codigoEmpl"
              v-validate.initial="'required|min:3'"
              :state="!errors.has('codigoEmpl')"
            />
            <span class="text-danger fs-6" v-show="errors.has('codigoEmpl')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Correo Eletrónico ">
            <b-form-input
              class="form-control"
              type="email"
              v-model="usuario.email"
              placeholder="referencia@example.com"
              data-vv-validate-on="blur|input"
              data-vv-name="email"
              v-validate.initial="'required|email'"
              :state="!errors.has('email')"
            />
            <span class="text-danger fs-6" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Seleccionar rol" label-for="vi-rol">
            <b-form-select
              id="vi-rol"
              v-validate.initial="'required'"
              data-vv-validate-on="input"
              name="rol"
              :state="!errors.has('rol')"
              v-model="usuario.rol"
            >
            <b-form-select-option
                  v-for="(item, index) in roles"
                  :key="index"
                  :value="item.name"
                  >{{ item.name }}</b-form-select-option
                > 
            </b-form-select>
            <span v-if="errors.has('Rol')" class="text-danger"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
      </b-row>
      <div class="text-right">
        <b-button type="submit" variant="success">Crear usuario</b-button>
      </div>
    </form>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  props: {
    cleanForm: {
      type: Date,
    },
  },
  data() {
    return {
      usuario: {
        nombre: "",
        apellido: "",
        codigo: "",
        rol: "",
      },
    };
  },
  async mounted() {
    await this.$store.dispatch({ type: "user/getRoles" });
  },
  methods: {
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit("handleCreateUser", this.usuario);
        }
      });
    },
  },
  computed: {
    ...mapState({
      roles: (state) => state.user.roles 
    })
  },
  watch: {
    cleanForm() {
      this.usuario = {
        nombre: "",
        apellido: "",
        codigo: "",
        rol: "",
        email: "",
      };
    },
  },
};
</script>
<style scoped></style>
